import { useToast } from "@/shared/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/shared/components/ui/toast"
import { CheckCircle2, AlertTriangle, Info, AlertCircle } from "lucide-react"

const getToastIcon = (variant?: string) => {
  switch (variant) {
    case "success":
    case "default":
      return <CheckCircle2 className="h-5 w-5 text-green-500 shrink-0" />
    case "warning":
      return <AlertTriangle className="h-5 w-5 text-amber-500 shrink-0" />
    case "info":
      return <Info className="h-5 w-5 text-blue-500 shrink-0" />
    case "destructive":
      return <AlertCircle className="h-5 w-5 text-red-500 shrink-0" />
    default:
      return <CheckCircle2 className="h-5 w-5 text-green-500 shrink-0" />
  }
}

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, variant, ...props }) {
        return (
          <Toast key={id} variant={variant} {...props}>
            <div className="flex items-start gap-3">
              {getToastIcon(variant)}
              <div className="grid gap-1">
                {title && <ToastTitle>{title}</ToastTitle>}
                {description && (
                  <ToastDescription>{description}</ToastDescription>
                )}
              </div>
            </div>
            {action}
            <ToastClose />
          </Toast>
        )
      })}
      <ToastViewport />
    </ToastProvider>
  )
}
